import { createContext, useContext } from 'react';

const context = createContext(null);
export default context;
export const Provider = context.Provider;
export const useAnalytics = () => useContext(context);
